import { render, staticRenderFns } from "./AddConnection.vue?vue&type=template&id=154285b4&scoped=true"
import script from "./AddConnection.vue?vue&type=script&lang=js"
export * from "./AddConnection.vue?vue&type=script&lang=js"
import style0 from "./AddConnection.vue?vue&type=style&index=0&id=154285b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154285b4",
  null
  
)

export default component.exports